/*
  groom.bg: ways into the shop assistant, and what they lead to (Bulgarian storefront only; loaded
  by snippets/groom-ask.liquid, which also holds the loader, window.groomTrack and the click handler
  for every [data-groom-ask-about] button).

  - Ready questions name the visitor's pet: "{pet}" (data-groom-q) becomes «Рекс (лабрадор)» when
    a pet is saved (window.groomActivePet from assets/groom.js), so the assistant also gets the breed.
  - A link with ?ask=<question> (or ?ask=1 / #ask) opens the assistant: Instagram, Facebook, Viber,
    QR cards in parcels. ?src=<name> names the entry point in GA4 (default "link").
  - One hint above the bubble on product, collection and blog pages (text from data-teaser): after
    20 s or half the page, once per browser session, and not again for 3 days once closed.
  - ?pet=1 opens the «Моят любимец» dialog (the QR card in parcels).
  - GA4 events for the pet profile («Моят любимец» dialog and the account page link).
*/
(() => {
  const conf = (document.getElementById('groom-assistant') || {}).dataset;
  if (!conf || typeof window.groomAssistantOpen !== 'function') return;
  const track = (name, params) => { try { window.groomTrack(name, params); } catch (e) {} };
  const ss = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };
  const ls = {
    get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} },
  };

  /* ---------- the visitor's pet in the ready questions ---------- */
  const petPhrase = () => {
    let p = null;
    try { p = typeof window.groomActivePet === 'function' ? window.groomActivePet() : null; } catch (e) {}
    if (!p || !p.name) return '';
    const kind = String(p.breed || '').trim() || (p.species === 'cat' ? 'котка' : p.species === 'dog' ? 'куче' : '');
    // weight helps the assistant with amounts and sizes: the account profile's kg, else the quick profile's size class
    const kg = Number(p.weight || p.weight_kg) > 0 ? `${Number(p.weight || p.weight_kg)} кг`
      : ({small: 'до 10 кг', medium: '10–25 кг', large: 'над 25 кг'})[p.size] || '';
    const about = [kind, kg].filter(Boolean).join(', ');
    return about ? `${p.name} (${about})` : p.name;
  };
  const fillPet = () => {
    const pet = petPhrase();
    if (!pet) return;
    document.querySelectorAll('[data-groom-q]').forEach((b) => {
      const q = b.getAttribute('data-groom-q').split('{pet}').join(pet);
      b.textContent = q;
      b.setAttribute('data-question', q);
    });
  };

  /* ---------- ?ask= links ---------- */
  const deepLink = () => {
    let url;
    try { url = new URL(location.href); } catch (e) { return; }
    const q = url.searchParams.get('ask');
    const hash = location.hash === '#ask';
    if (q === null && !hash) return;
    const src = (url.searchParams.get('src') || 'link').replace(/[^a-z0-9_-]/gi, '').slice(0, 30) || 'link';
    url.searchParams.delete('ask');
    url.searchParams.delete('src');
    if (hash) url.hash = '';
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) {}
    const question = q && q !== '1' ? q.trim().slice(0, 300) : '';
    ss.set('groom-ask-teased', '1');                       // came for the assistant: no hint on top of it
    window.groomAssistantOpen({source: src, question});
  };

  /* ---------- the one-time hint above the bubble ---------- */
  const TEASE_X = 'groom-ask-teaser-x';
  const teaser = () => {
    const text = conf.teaser;
    const bubble = document.querySelector('[data-groom-ask]');
    if (!text || !bubble || ss.get('groom-ask-teased')) return;
    const closedAt = Number(ls.get(TEASE_X) || 0);
    if (closedAt && Date.now() - closedAt < 3 * 864e5) return;
    let shown = false, timer = 0;
    const busy = () => document.documentElement.classList.contains('ga-open') || bubble.hasAttribute('open') ||
      document.querySelector('dialog[open], .menu-drawer-container[open], cart-drawer-component [open]');
    const show = () => {
      if (shown) return;
      if (busy()) { timer = setTimeout(show, 8000); return; }  // try again once the visitor is done
      shown = true;
      off();
      ss.set('groom-ask-teased', '1');
      const box = document.createElement('div');
      box.className = 'g-tease';
      box.setAttribute('role', 'status');
      const go = document.createElement('button');
      go.type = 'button';
      go.className = 'g-tease__go';
      go.textContent = text;
      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'g-tease__x';
      x.setAttribute('aria-label', conf.teaserX || 'Затвори');
      x.textContent = '✕';
      box.append(go, x);
      document.body.appendChild(box);
      requestAnimationFrame(() => box.classList.add('is-on'));
      track('assistant_teaser_shown', {});
      const hide = () => { box.classList.remove('is-on'); setTimeout(() => box.remove(), 300); };
      const auto = setTimeout(hide, 15000);
      go.addEventListener('click', () => { clearTimeout(auto); hide(); track('assistant_teaser_click', {}); window.groomAssistantOpen({source: 'teaser'}); });
      x.addEventListener('click', () => { clearTimeout(auto); hide(); ls.set(TEASE_X, String(Date.now())); track('assistant_teaser_close', {}); });
      bubble.addEventListener('click', () => { clearTimeout(auto); hide(); }, {once: true});
    };
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h > 0.5) show();
    };
    const off = () => { clearTimeout(timer); removeEventListener('scroll', onScroll); };
    timer = setTimeout(show, 20000);
    setTimeout(() => { if (!shown) addEventListener('scroll', onScroll, {passive: true}); }, 6000);
  };

  /* ---------- pet profile ---------- */
  let petFrom = '';
  const petLink = () => {
    let url;
    try { url = new URL(location.href); } catch (e) { return; }
    if (!url.searchParams.has('pet')) return;
    url.searchParams.delete('pet');
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) {}
    const open = document.querySelector('[data-groom-pet-open]');
    if (!open) return;
    ss.set('groom-ask-teased', '1');
    petFrom = 'link';
    open.click();
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-groom-pet-open], .g-pet a[href]');
    if (!t) return;
    if (t.matches('[data-groom-pet-open]')) {
      track('pet_profile_open', {from: petFrom || (t.closest('.g-tabbar') ? 'tabbar' : 'header')});
      petFrom = '';
    }
    else if (t.closest('.g-pet')) track(t.closest('.g-pet__login') ? 'pet_profile_login' : 'pet_profile_account', {});
  });
  document.addEventListener('submit', (e) => {
    if (e.target.closest && e.target.closest('[data-groom-pet-form]')) track('pet_profile_save_local', {});
  });

  const start = () => { fillPet(); deepLink(); petLink(); teaser(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
